module.exports = __webpack_public_path__ + "img/sample-profile.36074e75.png";